<template>
  <section>
    <div class="columns">
      <div class="column has-text-right">
        <b-button
          :label="
            openedDetail.length === 0
              ? 'Expandir Observaciones'
              : 'Contraer Observaciones'
          "
          :icon-left="
            openedDetail.length === 0 ? 'plus-circle' : 'minus-circle'
          "
          type="is-blue-color"
          @click="
            openedDetail.length === 0
              ? (openedDetail = performances)
              : (openedDetail = [])
          "
        />
      </div>
    </div>
    <b-table
      striped
      :data="
        performances.filter((x) => x.alt_name_area === academicArea.alt_name)
      "
      paginated
      per-page="10"
      :pagination-simple="false"
      pagination-position="bottom"
      aria-next-label="Siguiente"
      aria-previous-label="Anterior"
      aria-page-label="Página"
      aria-current-label="Página actual"
      :opened-detailed="openedDetail"
      detailed
    >
      <b-table-column
        field="commitment_index"
        label="N°"
        width="5%"
        v-slot="props"
      >
        {{ props.row.commitment_index }}
      </b-table-column>
      <b-table-column
        field="alt_name_activity"
        label="Actividad Académica"
        v-slot="props"
      >
        {{ props.row.alt_name_activity }}
      </b-table-column>
      <b-table-column
        v-if="
          academicArea.name === 'DOCENCIA' ||
          academicArea.name === 'EDUCACION CONTINUA'
        "
        field="alt_name_activity"
        label="Asignatura"
        v-slot="props"
      >
        {{
          (function () {
            if (props.row.subject_code == null || props.row.subject_code === "")
              return "";
            const filtered = subjects.filter(
              (subject) => parseInt(props.row.subject_code) === subject.codigo
            );
            return filtered.length > 0 ? filtered[0].codigo_nombre : "";
          })()
        }}
      </b-table-column>
      <b-table-column
        field="is_weekly_hours"
        label="Tipo de Hora"
        v-slot="props"
      >
        {{ props.row.is_weekly_hours ? "Semanales" : "Semestrales" }}
      </b-table-column>
      <b-table-column
        field="hours_committed_semester_1"
        label="Horas Comprometidas 1er Semestre"
        v-slot="props"
      >
        {{ props.row.hours_committed_semester_1 }}
      </b-table-column>
      <b-table-column
        field="hours_committed_semester_2"
        label="Horas Comprometidas 2do Semestre"
        v-slot="props"
      >
        {{ props.row.hours_committed_semester_2 }}
      </b-table-column>
      <b-table-column
        field="hours_completed_semester_1"
        label="Horas Realizadas 1er Semestre"
        v-slot="props"
      >
        {{ props.row.hours_completed_semester_1 }}
      </b-table-column>
      <b-table-column
        field="hours_completed_semester_2"
        label="Horas Realizadas 2do Semestre"
        v-slot="props"
      >
        {{ props.row.hours_completed_semester_2 }}
      </b-table-column>
      <template #detail="props">
        <div class="content">
          <div class="box">
            <p>
              <b>Observaciones:</b>
              {{ props.row.observations }}
            </p>
          </div>
          <div class="table-container box">
            <b-table
              :data="props.row.evidences || []"
              :bordered="false"
              :striped="true"
              :narrowed="true"
              :hoverable="true"
              :mobile-cards="true"
              class="is-fullwidth"
            >
              <b-table-column
                field="file_type"
                label="Tipo"
                width="50"
                v-slot="{ row }"
              >
                <b-icon
                  :icon="getFileIcon(row.alt_name)"
                  :type="getFileIconColor(row.alt_name)"
                />
              </b-table-column>

              <b-table-column
                field="alt_name"
                label="Nombre del archivo"
                v-slot="{ row }"
              >
                {{ row.alt_name }}
              </b-table-column>

              <b-table-column
                field="created_at"
                label="Fecha de creación"
                v-slot="{ row }"
              >
                {{ formatDate(row.created_at) }}
              </b-table-column>

              <b-table-column
                field="actions"
                label="Acciones"
                width="140"
                v-slot="{ row }"
              >
                <div class="buttons is-centered">
                  <b-button
                    type="is-info"
                    icon-left="eye"
                    size="is-small"
                    @click="verEvidence(row)"
                  />
                </div>
              </b-table-column>

              <template #empty>
                <div class="has-text-centered p-4">
                  <b-icon
                    icon="folder-open"
                    size="is-large"
                    class="mb-2"
                  ></b-icon>
                  <p>No hay evidencias disponibles</p>
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </template>
      <template slot="empty" slot-scope="props">
        <div class="columns is-centered">
          <div class="column is-6 is-centered has-text-centered">
            <b-message type="is-warning">
              Aún no ha agregado Actividades para {{ academicArea.alt_name }}, a
              medida que agregue se irán mostrando en esta tabla.
            </b-message>
          </div>
        </div>
      </template>
    </b-table>
    <b-modal
      :active.sync="isPreviewModalActive"
      :width="1200"
      :can-cancel="['escape', 'outside']"
      scroll="keep"
    >
      <div class="card">
        <header class="card-header">
          <p class="card-header-title">
            {{ selectedEvidence ? selectedEvidence.alt_name : "" }}
          </p>
        </header>
        <div class="card-content">
          <div v-if="selectedEvidence" class="content has-text-centered">
            <!-- Previsualización basada en el tipo de archivo -->
            <div
              v-if="isImageFile(selectedEvidence.alt_name)"
              class="image-preview"
            >
              <img :src="getFileUrl(selectedEvidence)" class="preview-image" />
            </div>

            <div
              v-else-if="isPdfFile(selectedEvidence.alt_name)"
              class="pdf-preview"
            >
              <!-- Usando vue-pdf o incrustando el PDF -->
              <iframe
                :src="getFileUrl(selectedEvidence)"
                class="pdf-frame"
                width="100%"
                height="500"
              ></iframe>
            </div>

            <div v-else class="file-info">
              <b-icon
                :icon="getFileIcon(selectedEvidence.alt_name)"
                :type="getFileIconColor(selectedEvidence.alt_name)"
                size="is-large"
              >
              </b-icon>
              <p class="mt-3">
                Este tipo de archivo no se puede previsualizar.
                <br />
                <b-button
                  class="mt-2"
                  type="is-primary"
                  icon-left="download"
                  @click="downloadFile(selectedEvidence)"
                >
                  Descargar
                </b-button>
              </p>
            </div>
          </div>
        </div>
        <footer class="modal-card-foot">
          <div class="actions has-text-right">
            <button
              class="button"
              type="button"
              @click="isPreviewModalActive = false"
            >
              Cerrar
            </button>
            <button
              class="button is-primary"
              type="button"
              @click="downloadFile(selectedEvidence)"
            >
              Descargar
            </button>
          </div>
        </footer>
      </div>
    </b-modal>
  </section>
</template>

<script>
export default {
  props: {
    performances: {
      type: Array,
      required: true,
    },
    academicArea: {
      type: Object,
      required: true,
    },
    subjects: {
      type: Array,
    },
  },

  data() {
    return {
      openedDetail: [],
      activityId: null,
      isPreviewModalActive: false,
      selectedEvidence: null,
      isReplaceModalActive: false,
      fileToReplace: null,
      fileUpload: null,
      isUploading: false,
    };
  },
  methods: {
    getFileIcon(filename) {
      if (!filename) return "file";

      const extension = filename.split(".").pop().toLowerCase();

      if (["doc", "docx"].includes(extension)) return "file-word";
      if (["xls", "xlsx"].includes(extension)) return "file-excel";
      if (extension === "pdf") return "file-pdf";
      if (["jpg", "jpeg", "png", "gif", "bmp", "svg"].includes(extension))
        return "file-image";

      return "file";
    },

    getFileIconColor(filename) {
      if (!filename) return "";

      const extension = filename.split(".").pop().toLowerCase();

      if (["doc", "docx"].includes(extension)) return "is-info";
      if (["xls", "xlsx"].includes(extension)) return "is-success";
      if (extension === "pdf") return "is-danger";
      if (["jpg", "jpeg", "png", "gif", "bmp", "svg"].includes(extension))
        return "is-warning";

      return "";
    },

    verEvidence(evidence) {
      this.selectedEvidence = evidence;
      this.isPreviewModalActive = true;
    },
    isImageFile(filename) {
      if (!filename) return false;
      const extension = filename.split(".").pop().toLowerCase();
      return ["jpg", "jpeg", "png", "gif", "bmp", "svg"].includes(extension);
    },

    isPdfFile(filename) {
      if (!filename) return false;
      return filename.toLowerCase().endsWith(".pdf");
    },

    getFileUrl(evidence) {
      if (evidence.url) {
        return evidence.url;
      }
    },

    downloadFile(evidence) {
      if (!evidence) return;
      if (evidence.url) {
        window.open(evidence.url, "_blank");
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return "";

      const date = new Date(dateStr);

      // Formato chileno: DD-MM-YYYY HH:MM
      return new Intl.DateTimeFormat("es-CL", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      }).format(date);
    },
  },
};
</script>
